import { createSlice } from "@reduxjs/toolkit";

const reportsSlice = (name, defaultSortField = "createdAt", defaultSortOrder = "desc") => {
  const initialState = {
    pagination: { page: 0, pageSize: 15 },
    sortModel: [{ field: defaultSortField, sort: defaultSortOrder }],
    searchText: "",
  };

  const slice = createSlice({
  name,
  initialState,
  reducers: {
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
     resetPage: state => {
      state.pagination.page = 0;
    },
    resetState: (state) => Object.assign(state, initialState),
  },
});


  return slice;
};

export const wfhReportSlice = reportsSlice("wfhReports", "package_Name", "desc");

export const reportsReducers = {
  wfhReports: wfhReportSlice.reducer,
};
